<template>
  <d-list-group flush>
    <d-list-group-item class="p-0">
      <d-row>

        <d-col md="6" class="form-group">
          <d-form>
            <d-card class="card-small">
              <!-- Card Header -->
              <d-card-header class="border-bottom">
                <h6 class="m-0">Lista do Contratado</h6>
              </d-card-header>

              <d-card-body class="p-0 pb-1">
                <item-form-row
                  :list="hired"
                  type="hired"
                  @saveItem="saveObligation"
                  @editItem="editObligation"
                  placeholder="Adicione para o contratado"
                />
              </d-card-body>

            </d-card>
          </d-form>
        </d-col>
        <d-col md="6" class="form-group">
          <d-form>
            <d-card class="card-small">
              <!-- Card Header -->
              <d-card-header class="border-bottom">
                <h6 class="m-0">Lista do Contratante</h6>
              </d-card-header>

              <d-card-body class="p-0 pb-1">
                <item-form-row
                  :list="contractor"
                  type="contractor"
                  @saveItem="saveObligation"
                  @editItem="editObligation"
                  placeholder="Adicione para o contratante"
                />
              </d-card-body>

            </d-card>
          </d-form>
        </d-col>

      </d-row>

    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import SettingsService from '_services/rest/modules/settings';
import ContractualItems from '_common/mixins/ContractualItems';
import ItemFormRow from './ItemFormRow.vue';
import { OPTION } from './SettingsModel';
import { _OPEN_EDITOR_TEXT_MODAL_ } from '../../quotation/components/QuotationModel';

export default {
  name: 'obligations-form',
  mixins: [ContractualItems],
  components: {
    ItemFormRow,
  },
  data() {
    return {
    };
  },
  computed: {
    hired() {
      const { hired } = this.$store.state.settings;
      if (hired && hired.length > 0) {
        return hired;
      }
      return [{ ...OPTION }];
    },
    contractor() {
      const { contractor } = this.$store.state.settings;
      if (contractor && contractor.length > 0) {
        return contractor;
      }
      return [{ ...OPTION }];
    },
  },
  methods: {
    ...mapActions([
      'getHireds',
      'setToggle',
      'activeAlert',
      'getContractors',
    ]),
    getOptions() {
      this.getHireds();
      this.getContractors();
    },
    editObligation({ item, type, index }) {
      this.setToggle({ type: 'edit_editor_text_modal', bool: true });
      Events.$emit(_OPEN_EDITOR_TEXT_MODAL_, { item, type, index });
    },
    saveObligation({ index, type = 'contractor' }) {
      this.formatSlug(this[type][index]);
      SettingsService.saveQuotationContractualItems(this[type][index], type)
        .then(response => {
          this.updateItem(index, type, response);
          this.activeAlert({ message: 'Obrigação salva com sucesso', theme: 'success' });
          if (this.hired.length === 1) this.getHireds();
          if (this.contractor.length === 1) this.contractor();
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>
